module.exports = __webpack_public_path__ + "static/media/no_image.d7df5f12.svg";